import { Box } from "@mui/material"
import { Outlet } from "react-router-dom";
import Nav from "./incomeTaxNav";


const TanClientIncomeTaxView = () => {
    return (
        <Box >
            <Nav />
            <Outlet />
        </Box>
    )
}

export default TanClientIncomeTaxView
